import { FieldGroup, SpinnerApple } from '@/ui'
import { Button, cn } from '@dashboard/ui'
import { createElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IframeSizes, iframeSizeClasses, iframeSizeIcons } from './helpers'

export interface HubPopupIframeProps {
  src: string
  isLoadingPreview: boolean
  setIsLoadingPreview: (value: boolean) => void
}

export const HubPopupIframe = ({ src, isLoadingPreview, setIsLoadingPreview }: HubPopupIframeProps) => {
  const { t } = useTranslation()

  const [iframeSize, setIframeSize] = useState(IframeSizes.Desktop)

  const switchSize = (size: IframeSizes) => {
    if (iframeSizeClasses[size]) {
      setIframeSize(size)
    } else {
      console.warn(`Size "${size}" is not defined in iframeSizeClasses`)
    }
  }

  const iframeClass = iframeSizeClasses[iframeSize] ?? iframeSizeClasses[IframeSizes.Desktop]

  return (
    <div className="w-full">
      <div>
        <div className="mb-4 flex gap-2">
          {Object.values(IframeSizes).map(size => (
            <Button
              key={size}
              color={size === iframeSize ? 'primary' : 'secondary'}
              variant="default"
              onClick={() => switchSize(size)}
              size="md"
            >
              {typeof iframeSizeIcons[size] === 'function'
                ? createElement(iframeSizeIcons[size])
                : iframeSizeIcons[size]}
              {t('campaign.block.BrowserPopupNotificationActionNode.iframesize.' + size)}
            </Button>
          ))}
        </div>
      </div>
      <FieldGroup label={t('campaign.block.BrowserPopupNotificationActionNode.preview')} className="w-full">
        <div className={cn('w-full overflow-auto rounded-xl text-center')}>
          {isLoadingPreview && (
            <div
              style={{
                backgroundColor: '#090808',
              }}
              className="flex size-full items-center justify-center p-16 text-text-quarterary"
            >
              <SpinnerApple />
            </div>
          )}
          <iframe
            onLoad={() => {
              setIsLoadingPreview(false)
            }}
            className={cn(iframeClass)}
            src={src}
            frameBorder={0}
            scrolling="no"
            style={{
              overflowY: 'hidden',
              pointerEvents: 'none',
              display: isLoadingPreview ? 'none' : 'inline-block',
            }}
          />
        </div>
      </FieldGroup>
    </div>
  )
}
